/** Slide definitions, looks and starting text for The Wifey Application Builder. */

export const THEMES = [
  { id: 'autumn', name: 'Pumpkin Spice', desc: 'Warm, cozy, Autumn', kicker: 'Slide 02', swatch: 'sw-autumn' },
  { id: 'business', name: 'Polished Professional', desc: 'Classic, corporate, resume-style', kicker: 'Section 02', swatch: 'sw-business' },
  { id: 'rose', name: 'Rose Water', desc: 'Soft, feminine, graceful', kicker: 'Slide 02', swatch: 'sw-rose' },
];

// photo: 'arch' = a framed photo beside the heading, 'cover' = full-bleed, 'bg' = background image behind the text
export const SLIDES = [
  { id: 'cover', label: 'Cover', photo: 'cover', tip: 'Keep the tagline to a sentence. Warm and confident beats clever.',
    fields: [
      { k: 'title', label: 'Title', type: 'text', max: 34, def: 'The Wifey Application' },
      { k: 'tagline', label: 'Tagline', type: 'area', max: 120, def: 'Bismillah. I am looking for my husband, and I am doing it with intention.' },
    ] },
  { id: 'about', label: 'About me', photo: 'arch', tip: 'Skip personal details like your workplace, address and phone number.',
    fields: [
      { k: 'name', label: 'What should we call you? (first name or initials)', type: 'text', max: 20, def: 'Yusra' },
      { k: 'age', label: 'Age', type: 'text', max: 8, def: '31' },
      { k: 'place', label: 'Based in (city or region only)', type: 'text', max: 30, def: 'Chicago area' },
      { k: 'work', label: 'Work', type: 'text', max: 34, def: 'Nurse and weekend baker' },
      { k: 'known', label: 'Best known for', type: 'area', max: 100, def: 'Hosting dinner parties, laughing too loudly, and always having a book in my bag.' },
    ] },
  { id: 'deen', label: 'My deen', photo: 'bg', tip: 'Say it honestly. Growth is attractive, perfection is not required.',
    fields: [
      { k: 'deen', label: 'My relationship with Allah right now', type: 'area', max: 230,
        def: 'My faith is the center of my life. I am steady in my five prayers, learning to love Quran more each week, and I want a home where we remind each other of Allah.' },
    ] },
  { id: 'seeking', label: 'Who I am seeking', photo: 'arch', tip: 'Lead with character. A short list filters better than a long list of demands.',
    fields: [
      { k: 'ageR', label: 'Age range', type: 'text', max: 16, def: '29 to 38' },
      { k: 'love', label: 'Must love', type: 'text', max: 44, def: 'Allah, kids, and good food' },
      { k: 'traits', label: 'Preferences', type: 'area', max: 170, def: 'Kind, honest, communicative, and committed to growing. Someone who keeps his word and laughs easily.' },
    ] },
  { id: 'why', label: 'Why I am doing this', photo: 'bg', tip: 'Say it with confidence. There is nothing to apologize for.',
    fields: [
      { k: 'why', label: 'Why I am putting this out there', type: 'area', max: 230,
        def: 'I am tying my camel and taking action with the intention of seeking a halal union. I would rather be intentional than leave it to chance, and I trust Allah with the rest.' },
    ] },
  { id: 'apply', label: 'How to apply', photo: null, tip: 'Your wali reviews applications with you. Never share your own phone number or address here.',
    fields: [
      { k: 'link', label: 'Link to your application form', type: 'text', max: 40, def: 'link in my bio' },
      { k: 'closes', label: 'Applications close on', type: 'text', max: 24, def: 'December 1' },
      { k: 'wali', label: 'Add the line: "DMs will not receive a response. My wali reviews every application."', type: 'check', def: true },
    ] },
];

export const defaultValues = () => {
  const v = {};
  SLIDES.forEach((s) => s.fields.forEach((f) => { v[`${s.id}.${f.k}`] = f.def; }));
  return v;
};

export const EMAIL_TYPOS = {
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com',
  'gmail.con': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.cm': 'gmail.com',
  'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
  'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.con': 'yahoo.com',
  'outlok.com': 'outlook.com', 'outlook.con': 'outlook.com', 'iclod.com': 'icloud.com', 'icloud.con': 'icloud.com',
};

/** "amina@gmial.com" -> "amina@gmail.com", or null when nothing looks off. */
export const suggestEmail = (email) => {
  const m = String(email || '').trim().toLowerCase().match(/^(.+)@([^@\s]+)$/);
  if (!m) return null;
  const fixed = EMAIL_TYPOS[m[2]];
  return fixed ? `${m[1]}@${fixed}` : null;
};
